<template>
    <navbar
            position="fixed"
            type="primary"
            :transparent="transparent"
            :color-on-scroll="colorOnScroll"
            menu-classes="ml-auto"
    >

        <template slot="navbar-menu">
            <div class="nav-photo-container">
                <img :src="userModel.userData.userNewImage" alt="UserImage"/>
            </div>
            <el-tooltip
                    class="item"
                    content="جهت تماس و ارسال درخواست به پایین صفحه بخش درخواست مراجعه فرمائید."
                    placement="bottom"
            >
                <div class="navbar-brand mt-4 text_bold text-warning">
                    {{userModel.userData.fullName}}
                </div>
            </el-tooltip>
            <li class="nav-item ">
                <div class="" style="height: 30px;width: 2px;background-color: white;margin-top: 30px;"></div>
            </li>

            <li class="nav-item  mt-4" v-for="rezomeDta in userModel.rezomeDta" :key="rezomeDta.mainItemTitle">
                <a class="nav-link" href="/">
                    <i class="now-ui-icons arrows-1_cloud-download-93"></i>
                    <p>{{rezomeDta.mainItemTitle}}</p>
                </a>
            </li>
            <!--<drop-down-->
            <!--tag="li"-->
            <!--title="منوی دراپ"-->
            <!--icon="now-ui-icons design_app"-->
            <!--class="nav-item mt-4"-->
            <!--&gt;-->
            <!--<nav-link to="/">-->
            <!--<i class="now-ui-icons business_chart-pie-36"></i>منوی دوم-->
            <!--</nav-link>-->
            <!--<a-->
            <!--href="https://demos.creative-tim.com/vue-now-ui-kit/documentation"-->
            <!--target="_blank"-->
            <!--class="dropdown-item"-->
            <!--&gt;-->
            <!--<i class="now-ui-icons design_bullet-list-67"></i>منوی سوم-->
            <!--</a>-->
            <!--</drop-down>-->
            <!--<drop-down-->
            <!--tag="li"-->
            <!--title="منوی دراپ دوم"-->
            <!--icon="now-ui-icons design_image"-->
            <!--class="nav-item mt-4"-->
            <!--&gt;-->
            <!--<nav-link to="/landing">-->
            <!--<i class="now-ui-icons education_paper"></i>صفحه اصلی-->
            <!--</nav-link>-->
            <!--<nav-link to="/login">-->
            <!--<i class="now-ui-icons users_circle-08"></i> ورود-->
            <!--</nav-link>-->
            <!--<nav-link to="/profile">-->
            <!--<i class="now-ui-icons users_single-02"></i> پروفایل-->
            <!--</nav-link>-->
            <!--</drop-down>-->
            <!--<li class="nav-item">-->
            <!--<a-->
            <!--class="nav-link btn btn-neutral"-->
            <!--href="https://www.creative-tim.com/product/vue-now-ui-kit-pro"-->
            <!--target="_blank"-->
            <!--&gt;-->
            <!--<i class="now-ui-icons arrows-1_share-66"></i>-->
            <!--<p>Upgrade to PRO</p>-->
            <!--</a>-->
            <!--</li>-->
            <li class="nav-item ">
                <div class="" style="height: 30px;width: 2px;background-color: white;margin-top: 30px;"></div>
            </li>
            <!--<div class="float-left">-->
            <li class="nav-item mt-4 " v-for="mynet in userModel.netData" :key="mynet.id">
                <a
                        class="nav-link"
                        rel="tooltip"
                        :title="mynet.name"
                        data-placement="bottom"
                        :href="mynet.urlLink !== undefined && mynet.urlLink !== null ? mynet.urlLink: ''"
                        target="_blank"
                >
                    <i class="fab " :class="mynet.icon"></i>
                    <p class="d-lg-none d-xl-none">{{mynet.name}}</p>
                </a>
            </li>
            <!--</div>-->
            <!--<li class="nav-item">-->
            <!--<a-->
            <!--class="nav-link"-->
            <!--rel="tooltip"-->
            <!--title="Like us on Facebook"-->
            <!--data-placement="bottom"-->
            <!--href="https://www.facebook.com/CreativeTim"-->
            <!--target="_blank"-->
            <!--&gt;-->
            <!--<i class="fab fa-facebook-square"></i>-->
            <!--<p class="d-lg-none d-xl-none">Facebook</p>-->
            <!--</a>-->
            <!--</li>-->
            <!--<li class="nav-item">-->
            <!--<a-->
            <!--class="nav-link"-->
            <!--rel="tooltip"-->
            <!--title="Follow us on Instagram"-->
            <!--data-placement="bottom"-->
            <!--href="https://www.instagram.com/CreativeTimOfficial"-->
            <!--target="_blank"-->
            <!--&gt;-->
            <!--<i class="fab fa-instagram"></i>-->
            <!--<p class="d-lg-none d-xl-none">Instagram</p>-->
            <!--</a>-->
            <!--</li>-->
        </template>
    </navbar>
</template>

<script>
    import {DropDown, Navbar, NavLink} from '@/components';
    import BaseService from "../_framework/api/BaseService";
    import Constants from "../_framework/Constants";
    import Utils from "../_framework/utils/Utils";
    import {Popover, Tooltip} from 'element-ui';
    // import 'assets/fonts/fonts.scss';

    export default {
        name: 'main-navbar',
        props: {
            transparent: Boolean,
            colorOnScroll: Number
        },
        components: {
            // DropDown,
            Navbar,
            // NavLink,
            [Popover.name]: Popover,
            [Tooltip.name]: Tooltip,
        },
        data() {
            return {

                netMode: "",
                isLoading: false,
                userModel: {
                    userData: {
                        city: "",
                        fullName: "",
                        mainJob: "",
                        provience: "",
                        userImage: ""
                    },
                    netData: [{
                        icon: "",
                        name: "",
                        number: "",
                        urlLink: ""
                    }]
                },


            }
        },
        mounted() {
            this.getUserData();

        },
        methods: {
            getUserData() {
                this.isLoading = true;
                let p = {
                    userId: Constants.USER_ID
                };
                new BaseService("RezomeReport", "/GetUserDatas").getList(p).then(response => {
                    this.isLoading = false;
                    // console.log("da-----");
                    // console.log(response.data);
                    this.userModel = response.data;
                    // this.userModel.userData.userNewImage = this.validateImageUrl(this.userModel.userData.userImage)
                    this.userModel.userData.userNewImage = Constants.BASE_URL + "/" + this.userModel.userData.userImage;
                    // console.log(this.userModel.userData.userNewImage);

                    // if (this.userModel.birthDay !== null) {
                    //     this.birthDay = Moment(this.gregorianToJalali(this.userModel.birthDay), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                    // }
                }).catch(error => {
                    // console.log(error);
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
        }
    };
</script>

<style scoped></style>
